import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesProcessoDigital.vue?vue&type=template&id=2a3b0988"
import script from "./LicitacaoAtualizacaoAcoesProcessoDigital.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesProcessoDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports